import { connect } from 'react-redux';
import Dashboard from '../../components/Dashboard/Dashboard';
import { checkFeatureAccess } from '../../utils/helpers';
import globals from '../../globals/communityGlobals';

const mapStateToProps = ({ global: { auth } }) => {
  const access = auth.featureAccessList;
  return {
    access,
    canEditTreatments: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canEditTreatments),
  };
};

const DashboardPage = connect(
  mapStateToProps,
  null,
)(Dashboard);

export default DashboardPage;
